import { supabase } from './supabase.js';

/**
 * Partners verificados con rol activo venue | store | pickup (RPC público).
 * @returns {Promise<Array<object>>}
 */
export async function fetchPartnersPublicLugares() {
  const { data, error } = await supabase.rpc('list_partners_public_lugares');
  if (error) {
    console.error('[lugaresPublicosService] list_partners_public_lugares:', error.message);
    return [];
  }
  return Array.isArray(data) ? data : [];
}
